import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "inputRef", "options", "value", "onAccept", "onComplete", "preventActiveUpdate"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { clsx } from 'clsx';
import IMask from 'imask';
import { useEventCallback, useForkRef } from '@cian/react-utils';
import { useUpdateEffect } from '../../hooks';
import styles from './styles.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const IMaskInput = /*#__PURE__*/React.forwardRef(function IMaskInput(props, ref) {
  const {
      as: Input = 'input',
      inputRef: propsInputRef,
      options: propsOptions,
      value,
      onAccept,
      onComplete,
      preventActiveUpdate
    } = props,
    inputProps = _objectWithoutProperties(props, _excluded);
  const inputRef = React.useRef(null);
  const handleInputRef = useForkRef(ref, inputRef, propsInputRef);
  const maskRef = React.useRef(null);
  const hasPlaceholder = !!props.placeholder;
  const defaultLazy = hasPlaceholder;
  const options = React.useMemo(() => _objectSpread({
    lazy: defaultLazy
  }, propsOptions),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [propsOptions, 'lazy' in propsOptions || defaultLazy]);
  const getMaskValue = () => {
    const maskInstance = maskRef.current;
    if (!maskInstance) {
      return '';
    }
    return maskInstance.unmaskedValue;
  };
  const setMaskValue = value => {
    const maskInstance = maskRef.current;
    if (!maskInstance) {
      return;
    }
    maskInstance.unmaskedValue = typeof value === 'undefined' ? '' : String(value);
  };
  const handleAccept = useEventCallback(() => {
    const maskInstance = maskRef.current;

    // Для исключения ситуаций когда обновляется только снаружи
    if (!maskInstance || !isIMaskActive(maskInstance)) {
      return;
    }
    if (onAccept) {
      onAccept(getMaskValue(), maskInstance);
    }
  });
  const handleComplete = useEventCallback(() => {
    const maskInstance = maskRef.current;

    // Для исключения ситуаций когда обновляется только снаружи
    if (!maskInstance || !isIMaskActive(maskInstance)) {
      return;
    }
    if (onComplete) {
      onComplete(getMaskValue(), maskInstance);
    }
  });
  React.useEffect(() => {
    maskRef.current = IMask(inputRef.current, options).on('accept', handleAccept).on('complete', handleComplete);
    setMaskValue(props.value || '');
    return () => {
      if (maskRef.current) {
        maskRef.current.destroy();
        maskRef.current = null;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useUpdateEffect(() => {
    var _maskRef$current;
    const maskInstance = maskRef.current;
    if (!maskInstance) {
      return;
    }
    maskInstance.updateOptions(options);
    (_maskRef$current = maskRef.current) === null || _maskRef$current === void 0 || _maskRef$current.alignCursor();
  }, [options]);
  useUpdateEffect(() => {
    const maskInstance = maskRef.current;

    /**
     * Не обновляяем значение в инпуте, если сейчас идет процесс ввода значения.
     * Потому что:
     * * Могут быть проблемы с вводом слишком больших чисел
     * * Могут быть проблемы с вводом отрицательных чисел
     */
    if (preventActiveUpdate && (!maskInstance || maskInstance.el.isActive)) {
      return;
    }
    setMaskValue(value);
  }, [value]);
  return /*#__PURE__*/_jsx(Input, _objectSpread(_objectSpread({
    ref: handleInputRef
  }, inputProps), {}, {
    className: clsx(inputProps.className, styles['input']),
    defaultValue: value
  }));
});
function isIMaskActive(instance) {
  return !!instance.el.isActive;
}